"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useTrackOpenLoadEvent = exports.useTrackLoadEvent = exports.useTrackEvent = void 0;
var _react = require("react");
var _useAnalytics = _interopRequireDefault(require("./useAnalytics"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const useTrackEvent = _ref => {
  let {
    reportService,
    reportType,
    reportFormat
  } = _ref;
  const {
    trackEvent
  } = (0, _useAnalytics.default)({
    eventNamePrefix: 'reports.panel',
    service: reportService
  });
  const trackOpen = openedFrom => {
    const details = openedFrom ? {
      opened_from: openedFrom
    } : {};
    trackEvent({
      eventName: 'open',
      details
    });
  };
  const trackClose = onClose => () => {
    trackEvent({
      eventName: 'close'
    });
    onClose();
  };
  const trackBeforeSubmit = function () {
    let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    let afterTracking = arguments.length > 1 ? arguments[1] : undefined;
    return () => {
      const {
        filter,
        sort,
        components
      } = options;
      const filter_count = filter?.length ?? 0;
      const sort_count = sort?.length ?? 0;
      const filters = {};
      const sorts = {};
      if (filter_count > 0) {
        filter.forEach((_ref2, index) => {
          let {
            field
          } = _ref2;
          filters[`filter_${index + 1}`] = field;
        });
      }
      if (sort_count > 0) {
        sort.forEach((_ref3, index) => {
          let {
            field
          } = _ref3;
          sorts[`sort_${index + 1}`] = field;
        });
      }
      trackEvent({
        eventName: 'run',
        details: {
          template: reportType,
          file_format: reportFormat,
          filter_count,
          sort_count,
          ...filters,
          ...sorts,
          components
        }
      });
      afterTracking();
    };
  };
  const trackShowProgressView = () => trackEvent({
    eventName: 'progress.view',
    details: {
      template: reportType
    }
  });
  const trackOnComplete = result => trackEvent({
    eventName: 'complete.view',
    details: {
      template: reportType,
      result
    }
  });
  const trackCopyLink = () => {
    trackEvent({
      eventName: 'copylink',
      details: {
        template: reportType
      }
    });
  };
  const trackDownload = reportUrl => () => {
    trackEvent({
      eventName: 'download',
      details: {
        template: reportType
      }
    });
    window.open(reportUrl, '_blank');
  };
  return {
    trackOpen,
    trackClose,
    trackBeforeSubmit,
    trackShowProgressView,
    trackOnComplete,
    trackDownload,
    trackCopyLink
  };
};
exports.useTrackEvent = useTrackEvent;
const useTrackLoadEvent = trackEvent => {
  (0, _react.useEffect)(() => {
    trackEvent();
  }, []);
};
exports.useTrackLoadEvent = useTrackLoadEvent;
const useTrackOpenLoadEvent = _ref4 => {
  let {
    trackEvent,
    isOpen,
    openedFrom
  } = _ref4;
  (0, _react.useEffect)(() => {
    if (isOpen) {
      trackEvent(openedFrom);
    }
  }, [isOpen]);
};
exports.useTrackOpenLoadEvent = useTrackOpenLoadEvent;